<!-- <section class="text-center py-16 px-6">
    <div class="container mx-auto max-w-7xl">
      <h1 class="text-4xl font-extrabold animate-fade-in-up">
        We offer a diverse range of programs
      </h1>
      <p
        class="text-gray-500 mt-4 text-lg md:text-xl animate-fade-in-up delay-100"
      >
        Designed to inspire learning and development across various domains.
      </p>
      <div class="mt-8 space-y-8">
        <div
          *ngFor="let org of organizations"
          class="bg-white shadow-lg rounded-lg p-6 hover:shadow-2xl transition-all duration-300 animate-fade-in-up delay-400 flex flex-col space-y-4"
        >
          <div
            class="flex flex-col sm:flex-row items-center sm:items-start gap-6"
          >
            <div class="w-full sm:w-1/2 space-y-4 text-left">
              <h3 class="text-2xl font-bold text-gray-800">
                {{ org.category }}
              </h3>
              <p class="text-lg font-small text-gray-600">
                {{ org.purpose }}
              </p>
              <div
                *ngIf="org.features; else noFeatures"
                [innerHTML]="org.features"
                class="mt-4 text-gray-500 prose prose-gray max-w-none"
              ></div>
              <ng-template #noFeatures>
                <p class="mt-4 text-gray-400 italic">No features available.</p>
              </ng-template>
              <a
                (click)="goToExplorePrograms(org.id)"
                title="Click to view more"
                class="inline-flex items-center gap-2 mt-6 bg-teal-900 text-white px-6 py-3 rounded-full hover:bg-teal-700 hover:scale-105 transition-all duration-300 group cursor-pointer"
              >
                <span class="text-sm font-medium">Explore Now</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 group-hover:translate-x-1 transition-transform duration-300"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </a>
            </div>
            <div class="w-full sm:w-1/2">
              <img
                src="assets/TrailFusion/Miscellaneous/STEM.webp"
                alt="Program Showcase"
                class="w-full h-64 sm:h-[16rem] object-cover rounded-xl shadow-sm hover:scale-105 transition-transform duration-300"
              />
            </div>
          </div>
          <div
            class="flex items-center justify-center border-t pt-6 mt-10 px-4"
          >
            <span class="text-gray-500 text-sm mr-6 whitespace-nowrap"
              >Presented by</span
            >
            <div class="flex items-center space-x-4">
              <img
                [src]="org.orgImage"
                alt="Org Logo"
                class="h-12 sm:h-14 object-contain w-auto max-w-[140px]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> -->
<body class="font-sans bg-gray-50">
  <app-header></app-header>
  <!-- Hero Section -->
  <section>
    <div class="relative w-full h-[400px] flex justify-center items-center">
      <img
        src="assets/TrailFusion/banner-explore.jpg"
        alt="banner"
        class="absolute inset-0 w-full h-full object-cover brightness-75"
      />
      <div class="relative text-white text-center px-4 animate-fade-in">
        <h1 class="text-4xl font-extrabold">
          Rated Among the <a href="" class="text-teal-600">Top Organizations</a>
        </h1>
        <h2 class="text-lg mt-2 font-semibold">
          Your future starts here with quality programs.
        </h2>
      </div>
    </div>
  </section>

  <section class="text-center py-16 px-6">
    <div class="container mx-auto max-w-7xl">
      <h1 class="text-4xl font-extrabold animate-fade-in-up">
        We offer a diverse range of programs
      </h1>
      <p
        class="text-gray-500 mt-4 text-lg md:text-xl animate-fade-in-up delay-100"
      >
        Designed to inspire learning and development across various domains.
      </p>

      <div class="mt-8 space-y-8">
        <div
          *ngFor="let cat of categories; let i = index"
          class="bg-white shadow-lg rounded-lg p-6 hover:shadow-2xl transition-all duration-300 animate-fade-in-up delay-400 flex flex-col sm:flex-row sm:items-center text-left"
          [ngClass]="{ 'sm:flex-row-reverse': i % 2 !== 0 }"
        >
          <!-- Text section -->
          <div
            class="w-full sm:w-1/2"
            [ngClass]="{ 'sm:pl-8': i % 2 !== 0, 'sm:pr-8': i % 2 === 0 }"
          >
            <h3 class="text-2xl font-semibold mb-2 text-left">
              {{ cat.categoryName }}
            </h3>
            <p class="mt-2 text-gray-600 text-left">
              {{ cat.categoryDesc }}
            </p>
            <a
              [routerLink]="['/explore-programs']"
              [queryParams]="{ categoryId: cat.id }"
              class="inline-flex items-center gap-2 mt-6 bg-teal-900 text-white px-6 py-3 rounded-full hover:bg-teal-700 hover:scale-105 transition-all duration-300 group"
            >
              <span class="text-sm font-medium">Explore Now</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 group-hover:translate-x-1 transition-transform duration-300"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </a>
          </div>

          <!-- Image section -->
          <div
            class="w-full sm:w-1/2 mt-4 sm:mt-0"
            [ngClass]="{ 'sm:pr-8': i % 2 !== 0, 'sm:pl-8': i % 2 === 0 }"
          >
            <img
              [src]="getSafeUrl(cat.categoryImage)"
              [alt]="cat.categoryName"
              class="w-full h-[16rem] object-cover rounded-lg"
            />
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Welcome Modal -->
  <div
    *ngIf="showWelcomeModal"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4"
  >
    <div
      class="bg-white rounded-3xl shadow-2xl w-full max-w-4xl p-8 sm:p-12 md:p-16 text-center relative animate-fade-in-up"
    >
      <button
        (click)="closeModal()"
        class="absolute top-4 right-4 text-gray-500 hover:text-gray-800 text-3xl sm:text-4xl"
      >
        &times;
      </button>

      <h2
        class="text-2xl sm:text-3xl md:text-5xl font-extrabold text-gray-900 mb-6"
      >
        Welcome to TrailFusion 🎉
      </h2>

      <p
        class="text-base sm:text-lg md:text-2xl text-gray-700 mb-8 leading-relaxed max-w-3xl mx-auto"
      >
        Your one stop solution to all your problems and needs. Register your
        programs and activities with us now and get a
        <span class="font-bold text-green-600">$25 gift card!</span>
      </p>

      <button
        (click)="closeModal()"
        class="bg-teal-900 text-white px-8 sm:px-12 py-3 sm:py-4 text-lg sm:text-xl rounded-2xl shadow-lg hover:bg-teal-700 transition"
      >
        Got it!
      </button>
    </div>
  </div>
  <app-footer></app-footer>
</body>
<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"
/>
